import React, { Component, useState } from 'react';
import { Button } from 'antd';
import moment from 'moment';
import { gql, useApolloClient } from '@apollo/client';
import Spinner from '$components/library/Spinner';

const STAFF_ITEMS_EXPORT = gql`
  mutation StaffCreateItemsExport($input: CreateItemsExportInput!) {
    createItemsExport(input: $input) {
      itemsExport {
        uuid
        status
      }
    }
  }
`;

const STAFF_ITEMS_EXPORT_STATUS = gql`
  query StaffItemsExport($input: ItemsExportInput!) {
    itemsExport(input: $input) {
      itemsExport {
        uuid
        status
        exportUrl
      }
    }
  }
`;

class ExportStatus extends Component {
  constructor(props) {
    super(props);

    const { exportUuid, exportStatus } = props;

    const exportInterval = setInterval(() => {
      this.checkExport();
    }, 5000);

    this.state = {
      elapsedTime: 'just started',
      exportInterval,
      exportUuid,
      exportStatus,
      exportStart: moment().valueOf(),
    };
  }

  checkExport = async () => {
    const { client, exportUuid } = this.props;
    const { exportInterval, exportStart } = this.state;
    const seconds = Math.round((moment().valueOf() - exportStart) / 1000);

    this.setState({
      elapsedTime: `about ${seconds} seconds`,
    });

    const { data } = await client.query({
      fetchPolicy: 'network-only',
      query: STAFF_ITEMS_EXPORT_STATUS,
      variables: {
        input: {
          itemsExportUuid: exportUuid,
        },
      },
    });

    const {
      itemsExport: { itemsExport },
    } = data;
    const { status, exportUrl } = itemsExport;
    if (status !== 'pending') {
      clearInterval(exportInterval);
    }

    this.setState({
      exportStatus: status,
      exportUrl,
      elapsedTime: `about ${Math.round(
        (moment().valueOf() - exportStart) / 1000
      )} seconds`,
    });
  };

  render() {
    const { elapsedTime, exportUuid, exportStatus, exportUrl } = this.state;

    return (
      <div>
        {!exportUrl && (
          <div>
            This page will update periodically. If it takes more than two minutes,
            something is probably broken.
            <br />
            <br />
            <Spinner />
            <br />
            <br />
          </div>
        )}
        Export id: {exportUuid}
        <br />
        Export status: {exportStatus}
        <br />
        Elapsed time: {elapsedTime}
        <br />
        <br />
        {exportUrl && (
          <div>
            Right click save as:
            <br />
            <a href={exportUrl} target="_blank" rel="noopener noreferrer">
              {exportUrl}
            </a>
          </div>
        )}
      </div>
    );
  }
}

const FlashcardsExport = (props) => {
  const client = useApolloClient();
  const [exportUuid, setExportUuid] = useState(null);
  const [exportStatus, setExportStatus] = useState(null);
  const handleExport = async ({ client, isExam }) => {
    const { productUuid } = props;
    const { data } = await client.mutate({
      mutation: STAFF_ITEMS_EXPORT,
      variables: {
        input: {
          productUuid,
          isExam,
        },
      },
    });
    const {
      createItemsExport: { itemsExport },
    } = data;
    const { uuid, status } = itemsExport;
    setExportUuid(uuid);
    setExportStatus(status);
  };

  return (
    <div>
      <br />
      {exportUuid ? (
        <ExportStatus
          exportUuid={exportUuid}
          exportStatus={exportStatus}
          client={client}
        />
      ) : (
        <div>
          <Button onClick={() => handleExport({ client, isExam: false })}>
            Export non-exam flashcards
          </Button>
          <Button onClick={() => handleExport({ client, isExam: true })}>
            Export exam flashcards
          </Button>
        </div>
      )}
    </div>
  );
};

export default FlashcardsExport;
